import React, { lazy, Suspense } from "react";
import "./i18n";
import store from "./store/store";
import { Provider } from "react-redux";
import { Router } from "@reach/router";
import axios from "axios";

const Home = lazy(() => import("./pages/home"));
const Services = lazy(() => import("./pages/services"));
const Accommodation = lazy(() => import("./components/accommodation"));
const Car = lazy(() => import("./components/car"));
const AboutUs = lazy(() => import("./pages/about-us"));
const Excursion = lazy(() => import("./components/excursion"));
const Team = lazy(() => import("./pages/team/team"));

const App = () => {
  // axios.defaults.baseURL = "https://starmus.armeniatravel.am";
  axios.defaults.baseURL = "https://iengine.armeniatravel.am";

  return (
    <div>
      <Suspense fallback={"..."}>
        <Provider store={store}>
          <Router>
            <Home path="/">
              <Services path="/services">
                <Accommodation path="/accommodation" />
                <Car path={"/transportation"} />
                <Excursion path={"/excursion"} />
              </Services>
              <AboutUs path="/about-us" />
              <Team path="/team" />
            </Home>
          </Router>
        </Provider>
      </Suspense>
    </div>
  );
};

export default App;
